module.exports = __webpack_public_path__ + "static/media/contactIconTwo.6dd90e45.webp";